import "./Schedule.css";

export default function Schedule() {
  return (
    <div className="schedule" id="schedule">
      <div className="schedule_content">
        <h1>SCHEDULE</h1>
        <h3 className="schedule_container">COMING SOON</h3>
        
      </div>
    </div>
  );
}
